import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: ${theme.layout.chat_header_height} ${theme.layout.section_side}
      ${theme.layout.chat_navigation_height};
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    ${theme.fontStyle.title.section24_bold}
  `}
`;

export const Desc = styled.p`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body14_medium}
    color: ${theme.content.content_light_2};
  `}
`;

export const Article = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ArticleContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > p {
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.caption1};
    }
  `}
`;

export const ArticleTitle = styled.p`
  ${({ theme }) => css`
    ${theme.fontStyle.title.section20_bold}
    color: ${theme.content.content_light_2};
  `}
`;

export const SubSection = styled.div`
  ${({ theme }) => css`
    & > ol {
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      gap: 4px;

      & li {
        color: ${theme.content.caption1};
        ${theme.fontStyle.text.caption_medium}
      }
    }
  `}
`;

export const Table = styled.table`
  ${({ theme }) => css`
    border: 1px solid ${theme.stroke.stroke_1};
    color: ${theme.content.caption1};
    ${theme.fontStyle.text.caption_medium}

    & > thead {
      height: 30px;
      text-align: center;
    }

    & th {
      display: table-cell;
      padding: 4px;
      border: 1px solid ${theme.stroke.stroke_1};
      vertical-align: middle;
    }

    & td {
      display: table-cell;
      padding: 4px;
      border: 1px solid ${theme.stroke.stroke_1};
      vertical-align: middle;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        height: 100%;

        & > div:last-of-type {
          padding-left: 4px;
          border-left: 1px solid ${theme.stroke.stroke_1};
        }
      }
    }
  `}
`;
